import { usePrimaryEnvironmentId } from "../state/environments";
import { useActiveOrgId, useOrgs } from "../state/orgs";

/** A pending interaction belongs to one authenticated person and organization. */
export function useHostedInteractionScopeKey(): string | null {
  const environmentId = usePrimaryEnvironmentId();
  const organizationId = useActiveOrgId();
  const organizations = useOrgs();
  return environmentId &&
    organizationId &&
    organizations.viewer.userId &&
    !organizations.error &&
    organizations.orgs.some((org) => org.id === organizationId)
    ? JSON.stringify([environmentId, organizations.viewer.userId, organizationId])
    : null;
}
